export enum ONBOARDING_STATUS {
  ACTIVE = 'active',
  DEFAULT = 'default',
  COMPLETE = 'complete',
}
